/// <reference path="../../vendor/angular/angular.js" />
'use strict';

angular.module('userRequestProcessControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'angularMoment',
    'directives.IAMContact',
    'services.search',
    'services.processAccessRequest'
]);